<template>
  <div :class="actionDisabled ? 'px-5' : ''">
    <contact-channel-action-modal
      v-if="showModal"
      :show="showModal"
      :channel="activeChannel"
      @close="showModal = false"
    />
    <div class="channels-row">
      <div class="self-center">
        <button
          v-if="showPrev"
          class="carousel-arrow"
          type="button"
          aria-label="Previous"
          @click="prevPage"
        >
          &lt;
        </button>
      </div>
      <a
        v-for="channel in pagedChannels"
        :key="channel.key"
        class="contact-channel"
        :href="actionLink(channel)"
        target="_blank"
        @click="handleClick($event, channel)"
        @mouseenter="hovered = channel.key"
        @mouseleave="hovered = null"
      >
        <contact-channel-icon
          :channel="channel"
          :hovered="hovered === channel.key"
        />
        <span class="channel-title">{{ channel.title }}</span>
      </a>
      <div
        v-for="i in itemsPerPage - pagedChannels.length"
        :key="`empty-${i}`"
        class="contact-channel"
      />
      <div class="self-center">
        <button
          v-if="showNext"
          class="carousel-arrow"
          type="button"
          aria-label="Next"
          @click="nextPage"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ContactChannelActionModal from './ContactChannelActionModal.vue';
import ContactChannelIcon from './ContactChannelIcon.vue';

export default {
  name: 'ContactChannelsCarousel',
  components: {
    ContactChannelIcon,
    ContactChannelActionModal,
  },
  props: {
    channels: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 3,
    },
    actionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 0,
      hovered: null,
      showModal: false,
      activeChannel: null,
    };
  },
  computed: {
    pagedChannels() {
      const start = this.page * this.itemsPerPage;
      return this.channels.slice(start, start + this.itemsPerPage);
    },
    showNext() {
      return (this.page + 1) * this.itemsPerPage < this.channels.length;
    },
    showPrev() {
      return this.page > 0;
    },
  },
  methods: {
    nextPage() {
      if (this.showNext) this.page += 1;
    },
    prevPage() {
      if (this.showPrev) this.page -= 1;
    },
    actionLink(item) {
      return this.actionDisabled
        ? '#'
        : item.action_link.replace('{{input_value}}', item.value);
    },
    handleClick(event, channel) {
      if (this.actionDisabled) {
        event.preventDefault();
        return;
      }
      if (
        channel.key === 'EMAIL' ||
        channel.key === 'SMS' ||
        channel.key === 'PHONECALL'
      ) {
        event.preventDefault();
        this.showModal = true;
        this.activeChannel = channel;
      }
    },
  },
};
</script>

<style scoped>
.channels-row {
  display: flex;
  position: relative;
  width: 100%;
  padding: 1rem 0 0;
  justify-content: space-between;
}
.contact-channel {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  cursor: pointer;
}
.icon-wrapper {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  transition:
    background 0.2s,
    border 0.2s;
}
.service-icon {
  width: 36px;
  height: 36px;
  transition: filter 0.2s;
}
.channel-title {
  font-size: var(--font-size-mini, 0.75rem);
  color: #1f2d3d;
}
.carousel-arrow {
  background: none;
  border: none;
  font-size: var(--font-size-large, 1.375rem);
  cursor: pointer;
  color: #888;
  position: relative;
  z-index: 1;
}
</style>
